import { AbEntry } from './ab-entry';
import { Entity, EntityFields } from './entity';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response } from './response';
import { ValueAndDisplay } from './value-and-display';

export enum RelatedEntryFields {
  FromKey = 'FromKey',
  ToKey = 'ToKey',
  RelationType = 'RelationType',
  Key = EntityFields.Key,
  To = 'To',
}

export interface RelatedEntry extends Entity {
  [RelatedEntryFields.Key]: string | null;
  [RelatedEntryFields.FromKey]: string | null;
  [RelatedEntryFields.ToKey]: string | null;
  [RelatedEntryFields.RelationType]: ValueAndDisplay<string[]> | string;
  [RelatedEntryFields.To]: AbEntry | null;
}

export interface RelatedEntryReadRequest extends Request {
  RelatedEntry: ReadRequest<RelatedEntry>;
}

export interface RelatedEntryWriteRequest extends Request {
  RelatedEntry: WriteRequest<RelatedEntry>;
}

export interface RelatedEntryResponse extends Response {
  RelatedEntry: DataResponse<RelatedEntry>;
}

export type BatchWriteRequest<T> = {
  [key: string]: WriteRequest<T>;
};
